import React from 'react';
import { useFeatureValue } from '@growthbook/growthbook-react';
import MiniPDP from '../../components/MiniPDP/MiniPDP';
import { useRescueOnePageEligible } from '../RescueLanding/RescueBanner';
import RescueCheckout from './RescueCheckout';

/**
 * Reads 'ecom-rescue-one-page-checkout' and picks the page. Mounted only for eligible adopters
 * (`useRescueOnePageEligible`), so the flag is evaluated - and the A/B test's exposure logged - for them
 * alone, not for every Mini shopper. Off (control) is today's pdp and cart.
 */
function RescueAdopterPage() {
  const onePage = useFeatureValue('ecom-rescue-one-page-checkout', false);

  return onePage ? <RescueCheckout /> : <MiniPDP />;
}

/** /products/fi-mini. Everyone the one-page test is not for gets the pdp. */
export default function MiniProductRoute() {
  return useRescueOnePageEligible() ? <RescueAdopterPage /> : <MiniPDP />;
}
